/*
  grafana嵌入到赛象云by李小萱 
*/
<template>
    <div class="grafanaAnalog mainWrap" >
        <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);" >
            <!-- 左边导航栏 -->
            <el-aside style="width:auto;">
                <leftNav msg="/grafanaAnalog"></leftNav>
            </el-aside>
            <!-- 右侧主体部分 -->
            <el-container>
                <el-main>
                    <div class="mainWrao">
                        <iframe :src="ifreamUrl" frameborder="0" style="width:100%;min-height:90vh;" ></iframe>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import leftNav from "@/components/nav.vue"
export default {
    name: 'grafanaAnalog',
    components: {
        leftNav
    },
    data(){
        return{
            ifreamUrl:''
        }
    },
    computed: {
        islangChange () {
            return this.$store.state.lang
        }
    },
    watch: {
        islangChange (curval, oldval) {
            if (curval != oldval) {
                this.$nextTick(()=>{
                    this.$parent.reload()
                })
            }
        },  
    },
    mounted () {
      let route = localStorage.getItem('newroute')
      switch (route) {
        case 'test':
            this.ifreamUrl = 'http://f01.tst-cloud.com/d/fB3du3vnz/jiu-pian-ce-shi?orgId=43&kiosk=tv'
            break;
        case 'xinjiang':
            this.ifreamUrl = 'http://f03.tst-cloud.com/d/wzShPVAMk/xin-jiang-203chan-rao-ji-01si-fu-dian-ji-zhuang-tai?orgId=16&kiosk=tv&refresh=5s'
            break;
        case 'jiande':
            this.ifreamUrl = 'http://f05.tst-cloud.com/d/k_WQS3vMk/jian-de-01qian-duan-si-fu-zhuang-tai-101-105?orgId=15&kiosk=tv&refresh=5s'
            break;
        case 'yousheng':
            this.ifreamUrl = 'http://f06.tst-cloud.com/d/6VPswO7Mz/shan-dong-you-sheng-01qian-duan-si-fu-yun-xing-qing-kuang?orgId=30&refresh=5s&kiosk=tv'
            break;
        case 'xinguilun':
            this.ifreamUrl = 'http://f07.tst-cloud.com/?orgId=44&kiosk=tv'
            break;
        case 'guangzhouwanli':
            this.ifreamUrl = 'http://f08.tst-cloud.com/d/z0oUoR_Sz/xin-ban-gang-jiu-pian-shu-ju?orgId=46&kiosk=tv'
            break;
        case 'guojiluntai':
            this.ifreamUrl = 'http://f09.tst-cloud.com/?orgId=51&kiosk=tv'
            break;
        case 'shuangqiantyre':
            this.ifreamUrl = 'http://f11.tst-cloud.com/d/dw9Cr7JMz/ru-gao-san-gu-01qian-duan-si-fu-dian-ji-zhuang-tai?orgId=48&kiosk=tv'
            break;
        case 'qingquan':
            this.ifreamUrl = 'http://f12.tst-cloud.com/d/T1MyBvtMk/qing-quan-01qian-duan-si-fu-dian-ji-zhuang-tai?orgId=17&kiosk=tv'
            break;
        case 'huasheng':
            this.ifreamUrl = 'http://f13.tst-cloud.com/d/Udrjd0LMk327/1-5_01_qian-duan-si-fu-dian-ji-zhuang-tai?orgId=12&kiosk=tv'
            break;
        case 'hefeiwanli':
            this.ifreamUrl = 'http://f02.tst-cloud.com/d/MqkJTZXGk/b5ji-tai-01-qian-duan-si-fu-dian-ji-zhuang-tai?orgId=43&kiosk=tv'
            break;
        case 'jiandesanqi':
            this.ifreamUrl = 'http://f17.tst-cloud.com/d/UBLarWc7z/bcm401-chan-liang-fen-xi?kiosk=tv'
            break;
        case 'guilun':
            this.ifreamUrl = 'http://f04.tst-cloud.com/d/DiNvd9TMk26/gui-yang-san-gu-liu-hao-ji-01qian-duan-shu-ju?orgId=50&kiosk=tv&refresh=5s'
            break;
        case 'prinxchengshan':
            this.ifreamUrl = 'http://f19.tst-cloud.com/d/dFkKnOh7z/zhu-ji?orgId=1&kiosk=tv'
            break;
        case 'jiandefourth':
            this.ifreamUrl = 'http://f18.tst-cloud.com/d/JcD-a6V7z392/d1-436-jiu-pian-shu-ju?orgId=1&kiosk=tv&refresh=5s'
            break;   
        case 'haiantyre':
            this.ifreamUrl = 'http://f23.tst-cloud.com/d/cFFxa1P4k/ju-tai-06-guo-cheng-shu-ju?orgId=2&kiosk=tv'
            break;
        case 'chaoyanglangma':
            this.ifreamUrl = 'http://f25.tst-cloud.com/d/0PZqAt3Vk/lang-ma-94hao-ji-si-fu-shu-ju?orgId=1&kiosk=tv'
            break;      
      }
    },
    methods:{

    }
}
</script>
<style scoped>
.grafanaAnalog{
  min-width: 1000px!important;
  display: flex;
}
.mainWrao{
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 10px;
}
</style>
